import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import * as API from '../apiConfig';


const initialForm = {
  email: '',
  password: '',
};

function RegisterComponent() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState(initialForm);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = ({ target: { name, value } }) => {
    setFormData((current) => ({
      ...current,
      [name]: value,
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsLoading(true);
    setMessage('');
    setError('');

    try {
      const response = await fetch(`${API.AUTH_API_URL}/register`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'Registration failed');
      }

      setMessage(`${data.message} for ${data.email}`);
      setFormData(initialForm);

      window.setTimeout(() => {
        navigate('/login', {
          state: {
            email: data.email,
            successMessage: data.message,
          },
        });
      }, 1200);
    } catch (submitError) {
      setError(submitError.message || 'Unable to register right now');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="auth-shell">
      <div className="container py-5">
        <div className="row justify-content-center">
          <div className="col-12 col-md-10 col-lg-8 col-xl-6">
            <div className="card auth-card border-0 shadow-lg">
              <div className="card-body p-4 p-md-5">
                <p className="auth-kicker mb-2">Billing System</p>
                <h1 className="h2 fw-bold mb-3">Create your account</h1>
                <p className="text-secondary mb-4">
                  Register with your email and password to start using the app.
                </p>

                {message && (
                  <div className="alert alert-success" role="alert">
                    {message}
                  </div>
                )}

                {error && (
                  <div className="alert alert-danger" role="alert">
                    {error}
                  </div>
                )}

                <form onSubmit={handleSubmit}>
                  <div className="mb-3">
                    <label className="form-label" htmlFor="register-email">
                      Email address
                    </label>
                    <input
                      id="register-email"
                      name="email"
                      type="email"
                      className="form-control form-control-lg"
                      placeholder="name@example.com"
                      value={formData.email}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  <div className="mb-4">
                    <label className="form-label" htmlFor="register-password">
                      Password
                    </label>
                    <input
                      id="register-password"
                      name="password"
                      type="password"
                      className="form-control form-control-lg"
                      placeholder="Enter your password"
                      value={formData.password}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  <button
                    type="submit"
                    className="btn btn-primary btn-lg w-100"
                    disabled={isLoading}
                  >
                    {isLoading ? 'Creating account...' : 'Register'}
                  </button>
                </form>

                <p className="text-center text-secondary mt-4 mb-0">
                  Already have an account? <Link to="/login">Login here</Link>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default RegisterComponent;
